import { MapContainer, TileLayer, GeoJSON } from 'react-leaflet'
import { useEffect, useState } from 'react'
import 'leaflet/dist/leaflet.css'

const MapRTLH = () => {
  const [data, setData] = useState(null)

  useEffect(() => {
    fetch('/api/map/rtlh')
      .then(res => res.json())
      .then(setData)
      .catch(err => console.error('Gagal ambil data GeoJSON', err));
  }, []);

  return (
    <MapContainer center={[-0.8, 123.5]} zoom={10} style={{ height: "100vh" }}>
      <TileLayer
        attribution='&copy; OpenStreetMap'
        url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
      />
      {data && <GeoJSON data={data} />}
    </MapContainer>
  )
}

export default MapRTLH
